import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

const CofogsAccordion = ({ cofogs, handlePopulateTopics, handleSelectOrganisation }) => {
  return (
    <Accordion allowZeroExpanded>
      <ul className="column">
        {cofogs.length > 0 && cofogs.map((data, index) => (
          <AccordionItem key={index}>
            <li className='__secmb' style={{ fontWeight: "bold", display: "inline-block" }}>
              <AccordionItemButton>
                <input
                  type="checkbox"
                  value={data.cofog}
                  id={data.cofog}
                  onChange={event => handlePopulateTopics(event, index)}
                  style={{ display: "inline-block", marginRight: "5px", cursor: "pointer" }}
                />
                <label style={{ cursor: "pointer" }} htmlFor={data.cofog}>{data.cofog}</label>
              </AccordionItemButton>
              <AccordionItemPanel>
                <ul style={{ fontWeight: "normal", fontSize: "12px" }} className="truncate">
                  {data.organisations.length > 0 && data.organisations.map(organisation => (
                    <li key={organisation}>
                      <div className='__congflex'>
                        <input
                          type="checkbox"
                          value={organisation}
                          id={organisation}
                          onChange={event => handleSelectOrganisation(event, data.cofog)}
                          style={{ display: "inline-block", marginRight: "2px", width: "10px", height: "10px", cursor: "pointer" }}
                        />
                        <label className='__congflp' style={{ fontWeight: "normal", cursor: "pointer" }} htmlFor={organisation}>{organisation}</label>
                      </div>
                    </li>
                  ))}
                </ul>
              </AccordionItemPanel>
            </li>
          </AccordionItem>
        ))}
      </ul>
    </Accordion>
  );
};

export default CofogsAccordion;